module.exports = __webpack_public_path__ + "static/hacienda_datos-bb377dedb878d480f6abf91116598098.png";